import {
  Box,
  Button as MuiButton,
  Card,
  CircularProgress,
  Container,
  makeStyles,
  Typography
} from '@material-ui/core'
import { fade } from '@material-ui/core/styles'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import HowToRegOutlinedIcon from '@material-ui/icons/HowToRegOutlined'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import UBox from 'src/components/ui/Ubox'
import { SynRoutes } from 'src/core/consts/synRoutes'
import formatarDinheiro from 'src/core/formatacoes/formatarDinheiro'
import usePagamento from 'src/hooks/usePagamento'
import { useQueryParams } from 'src/hooks/useQuery'
import {
  IOpcaoFluxoPagamento,
  OPCOES_FLUXO_PAGAMENTO
} from 'src/core/consts/opcoesFluxoPagamento'
import { Alert } from '@material-ui/lab'
import {
  WHATSAPP_SYN_NUMERO as WHATSAPP_SYN,
  WHATSAPP_SYN_EXIBICAO
} from 'src/core/consts/whatsapp'
const WHATSAPP_MSG_PENDENCIA =
  'Olá! Estou tentando realizar o pagamento da minha proposta na Syn Saúde e recebi um aviso de pendência cadastral de um prestador que precisa de adequação. Podem me ajudar?'

const MENSAGEM_BLOQUEIO_PADRAO =
  'Existe uma pendência cadastral de um dos prestadores que necessita de adequação antes de realizar o pagamento. O pagamento está temporariamente indisponível. A equipe Syn já foi acionada e entrará em contato.'

function linkWhatsAppPendencia() {
  return `https://api.whatsapp.com/send?phone=${WHATSAPP_SYN}&text=${encodeURIComponent(
    WHATSAPP_MSG_PENDENCIA
  )}`
}

function paragrafosPorPonto(texto: string) {
  return texto
    .split('. ')
    .map(parte => parte.trim())
    .filter(Boolean)
    .map(parte => (parte.endsWith('.') ? parte : `${parte}.`))
}

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '& .logo-container': {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  [theme.breakpoints.down('sm')]: {
    container: {
      '& .logo-container': {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between'
      }
    }
  },
  boxPagamento: {
    background: '#fff',
    borderRadius: 8,
    boxShadow: '0px 0px 8px #ddd',
    marginBottom: 40,
    width: '100%',
    maxWidth: 720
  },
  cardIntro: {
    background: '#fff',
    borderRadius: 8,
    margin: 0,
    padding: theme.spacing(3),
    boxShadow: 'none'
  },
  valorTotalBox: {
    background: '#f5f5f5',
    borderRadius: 8,
    textAlign: 'center',
    padding: theme.spacing(3, 0, 0, 0),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  avisoBloqueio: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(2, 1)
  },
  iconeAvisoWrap: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    background: fade(theme.palette.secondary.main, 0.16),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2)
  },
  iconeAviso: {
    color: theme.palette.secondary.main,
    fontSize: 36
  },
  textoAviso: {
    maxWidth: 520
  },
  botaoWhatsapp: {
    marginTop: theme.spacing(2),
    textTransform: 'none',
    fontWeight: 600
  },
  opcaoBotao: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(2, 3),
    marginBottom: theme.spacing(1.5),
    background: '#f5f5f5',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'background 0.2s, border-color 0.2s',
    '&:hover': {
      background: '#eee',
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      '& .MuiTypography-root': {
        fontWeight: 450
      }
    }
  }
}))

interface ComoFuncionaPagamentoProps {
  onOpcaoEscolhida?: (opcao: IOpcaoFluxoPagamento) => void
}

export default function ComoFuncionaPagamento({
  onOpcaoEscolhida
}: ComoFuncionaPagamentoProps) {
  const styles = useStyles()
  const query = useQueryParams()
  const history = useHistory()
  const propostaId = query.get('p')
  const { obterResumoPagamento, loading, resumo } = usePagamento()
  const [primeiroLoading, setPrimeiroLoading] = useState(true)

  useEffect(() => {
    if (propostaId) {
      obterResumoPagamento(propostaId).then(carregou =>
        setPrimeiroLoading(!carregou)
      )
    } else {
      setPrimeiroLoading(false)
    }
  }, [propostaId])

  const handleAvista = () => {
    const opcao = OPCOES_FLUXO_PAGAMENTO.find(o => o.valor === 'total_a_vista')
    if (opcao) {
      if (onOpcaoEscolhida) {
        onOpcaoEscolhida(opcao)
      } else {
        history.push(
          `${SynRoutes.pagamento}?p=${propostaId}&fluxo=total_a_vista`
        )
      }
    }
  }

  const handleParcelado = () => {
    const opcao = OPCOES_FLUXO_PAGAMENTO.find(o => o.valor === 'parcelado')
    if (opcao) {
      if (onOpcaoEscolhida) {
        onOpcaoEscolhida(opcao)
      } else {
        history.push(`${SynRoutes.pagamento}?p=${propostaId}&fluxo=parcelado`)
      }
    }
  }

  if (loading || primeiroLoading) {
    return (
      <UBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{ height: '100vh' }}
      >
        <Box textAlign="center">
          <CircularProgress />
          <div>Carregando...</div>
        </Box>
      </UBox>
    )
  }

  const pagamentoBloqueado = !!resumo?.dadosRecebedorIncompleto
  const paragrafosBloqueio = paragrafosPorPonto(MENSAGEM_BLOQUEIO_PADRAO)

  if (pagamentoBloqueado) {
    return (
      <UBox>
        <Container maxWidth="lg" className={styles.container}>
          <UBox p={2} pb={6} className={styles.boxPagamento}>
            <Card
              className={styles.cardIntro}
              data-testid="aviso-recebedor-incompleto"
            >
              <UBox className={styles.avisoBloqueio}>
                <Box className={styles.iconeAvisoWrap} aria-hidden>
                  <HowToRegOutlinedIcon className={styles.iconeAviso} />
                </Box>
                <Typography
                  variant="h5"
                  color="primary"
                  gutterBottom
                  style={{ fontWeight: 600 }}
                >
                  Pagamento temporariamente indisponível
                </Typography>
                <UBox className={styles.textoAviso}>
                  {paragrafosBloqueio.map(paragrafo => (
                    <Typography key={paragrafo} variant="body1" paragraph>
                      {paragrafo}
                    </Typography>
                  ))}
                  <Typography variant="body2" color="textSecondary" paragraph>
                    Enquanto a adequação não for concluída, não é possível
                    avançar com o pagamento desta proposta.
                  </Typography>
                  <Typography variant="body2" color="textSecondary" paragraph>
                    Se preferir, fale conosco pelo WhatsApp — nossa equipe está
                    pronta para ajudar.
                  </Typography>
                </UBox>
                <MuiButton
                  variant="contained"
                  color="primary"
                  className={styles.botaoWhatsapp}
                  href={linkWhatsAppPendencia()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="botao-whatsapp-pendencia"
                >
                  Falar com a Syn no WhatsApp
                </MuiButton>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{ marginTop: 12 }}
                >
                  WhatsApp {WHATSAPP_SYN_EXIBICAO}
                </Typography>
              </UBox>
            </Card>
          </UBox>
        </Container>
      </UBox>
    )
  }

  return (
    <UBox>
      <Container maxWidth="lg" className={styles.container}>
        <UBox p={2} pb={6} className={styles.boxPagamento}>
          <Card className={styles.cardIntro}>
            <Typography
              variant="h5"
              color="primary"
              gutterBottom
              style={{ fontWeight: 600 }}
            >
              Como funciona o pagamento da sua cirurgia
            </Typography>
            <Typography variant="body2" paragraph>
              Para facilitar o acesso à sua cirurgia, o valor total foi
              organizado em <b>etapas de pagamento</b>. Isso acontece porque uma
              cirurgia envolve diferentes serviços e fornecedores e cada um
              deles possui regras próprias de cobrança.
            </Typography>
            <Typography variant="body2" paragraph>
              <b>O mais importante:</b>
              <br />
              Você sempre enxerga o valor total desde o início, com clareza e
              previsibilidade.
            </Typography>

            <UBox className={styles.valorTotalBox}>
              <Typography
                variant="subtitle1"
                color="primary"
                style={{ fontWeight: 600 }}
              >
                Valor total da proposta
              </Typography>
              <Typography
                variant="h5"
                color="primary"
                style={{ fontWeight: 300 }}
              >
                {formatarDinheiro(resumo?.valorTotal)}
              </Typography>
              <UBox>
                <UBox m={2} pb={2}>
                  <Alert severity="info">
                    <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                      O valor total da proposta contempla:
                    </Typography>
                    <Typography variant="body2" component="span">
                      {resumo?.itensContemplados}
                    </Typography>
                  </Alert>
                </UBox>
              </UBox>
            </UBox>

            <Typography
              variant="subtitle1"
              color="primary"
              style={{ fontWeight: 600, marginBottom: 12 }}
            >
              Como deseja pagar?
            </Typography>
            <button
              type="button"
              className={styles.opcaoBotao}
              onClick={handleAvista}
            >
              <Typography variant="body1">
                {OPCOES_FLUXO_PAGAMENTO[0].descricao}
              </Typography>
              <ChevronRightIcon color="action" />
            </button>
            <button
              type="button"
              className={styles.opcaoBotao}
              onClick={handleParcelado}
            >
              <Typography variant="body1">
                {OPCOES_FLUXO_PAGAMENTO[1].descricao}
              </Typography>
              <ChevronRightIcon color="action" />
            </button>
          </Card>
        </UBox>
      </Container>
    </UBox>
  )
}
